import { useEffect } from 'react';
import toast from 'react-hot-toast';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuthContext } from '../../context/AuthContext';

const LogoutPage = () => {
  const { logout } = useAuthContext();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    logout();
    navigate('/login');
    // wait a half a second so toast shows up
    setTimeout(() => {
      const reason = searchParams.get('reason');
      if (reason === 'manual') {
        toast.success('You have been logged out');
        return;
      }
      if (reason === 'password-updated') {
        toast.success('Password updated. Please log in again');
        return;
      }
      toast.error('Your session has expired, please log back in');
    }, 500);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [logout, navigate, searchParams]);
  return <></>;
};

export default LogoutPage;
